<div class="container">
  <div class="list-page-container">
    <h1 i18n="@@searchResults">Search Results</h1>
    <div class="list-page-content">

      <div class="filter-by-container" *ngIf="!isMobileView">
        <div class="filter-by-title">
          <p i18n="@@mealsCategories">Meals Categories</p>
          <div class="clear-all" (click)="onClearCategoriesClicked()">
            <p i18n="@@clear">Clear</p>
          </div>
        </div>
        <div class="filter-by-item" *ngFor="let category of merchantFilters?.categories; let i = index">
          <input type="checkbox" id="{{category.id}}" name="{{category.id}}" value="All"
                 [(ngModel)]="categoriesCheckBoxes[i]"
                 (change)="filterResults()">
          <label for="{{category.id}}">{{ category.name }}</label><br>
        </div>
        <div class="horizontal-separator"></div>
        <div class="filter-by-title">
          <p i18n="@@orderingOptions">Ordering Options</p>
        </div>
        <div class="filter-by-item" *ngIf="merchantFilters !== undefined && merchantFilters !== null">
          <input type="checkbox" id="{{merchantFilters.deliveryAvailable.name}}"
                 [(ngModel)]="deliveryAvailableCheckBox"
                 (change)="filterResults()"
                 name="{{merchantFilters.deliveryAvailable.name}}"
                 value="{{merchantFilters.deliveryAvailable.name}}">
          <label
            for="{{merchantFilters.deliveryAvailable.name}}">{{ merchantFilters.deliveryAvailable.name }}</label><br>
        </div>
        <div class="filter-by-item" *ngIf="merchantFilters !== undefined && merchantFilters !== null">
          <input type="checkbox" id="{{merchantFilters.pickupAvailable.name}}"
                 [(ngModel)]="pickUpAvailableCheckBox"
                 (change)="filterResults()"
                 name="{{merchantFilters.pickupAvailable.name}}" value="{{merchantFilters.pickupAvailable.name}}">
          <label for="{{merchantFilters.pickupAvailable.name}}">{{ merchantFilters.pickupAvailable.name }}</label><br>
        </div>
        <div class="horizontal-separator"></div>
        <div class="filter-by-price-container">
          <div class="filter-by-title">
            <p i18n="@@priceRange">Price Range (EGP)</p>
          </div>
          <div *ngIf="merchantFilters !== undefined && merchantFilters !== null">
            <mat-slider min="{{merchantFilters.price.min}}" max="{{merchantFilters.price.max}}" step="1" discrete
                        [displayWith]="format">
              <input matSliderStartThumb [(ngModel)]="minPrice" (change)="filterResults()" id="min">
              <input matSliderEndThumb [(ngModel)]="maxPrice" (change)="filterResults()" id="max">
            </mat-slider>
          </div>
          <div class="horizontal-separator"></div>
        </div>
        <div class="filter-by-title">
          <p i18n="@@readyWithin">Ready Within</p>
          <div class="clear-all" (click)="onClearReadyWithinClicked()">
            <p i18n="@@clear">Clear</p>
          </div>
        </div>
        <div class="filter-by-item" *ngFor="let readyWithin of merchantFilters.readyWithin.values; let i = index">
          <input type="checkbox" id="{{readyWithin.id}}" name="{{readyWithin.id}}" value="All"
                 [(ngModel)]="readyWithinCheckBoxes[i]"
                 (change)="filterResults()">
          <label for="{{readyWithin.id}}">{{ readyWithin.name }}</label><br>
        </div>
        <div class="horizontal-separator"></div>
        <div class="filter-by-title">
          <p i18n="@@mealStatus">Meal Status</p>
          <div class="clear-all" (click)="onClearCookStateClicked()">
            <p i18n="@@clear">Clear</p>
          </div>
        </div>
        <div class="filter-by-item" *ngFor="let mealStatus of merchantFilters.state.values; let i = index;">
          <input type="checkbox" id="{{mealStatus.id}}" name="{{mealStatus.id}}" value="{{mealStatus.id}}"
                 [(ngModel)]="mealStateCheckBoxes[i]"
                 (change)="filterResults()">
          <label for="{{mealStatus.id}}">{{ mealStatus.name }}</label><br>
        </div>
        <div class="horizontal-separator"></div>
        <div class="filter-by-title" *ngIf="merchantFilters !== null && merchantFilters!.deliveryAreas.isNotEmpty()">
          <p i18n="@@deliveryAreas">Delivery Areas</p>
          <div class="clear-all" (click)="onClearDeliveryAreasClicked()">
            <p i18n="@@clear">Clear</p>
          </div>
        </div>
        <div class="filter-by-item" *ngFor="let deliveryArea of deliveryAreas; let i = index;">
          <input type="checkbox" id="{{deliveryArea.id}}" name="{{deliveryArea.id}}" value="{{deliveryArea.id}}"
                 [(ngModel)]="deliveryAreasCheckBoxes[i]"
                 (change)="filterResults()">
          <label for="{{deliveryArea.id}}">{{ deliveryArea.name }}</label><br>
        </div>
        <div class="expand-delivery-ares" *ngIf="shouldShowMore()" (click)="showAllAreas()">
          <p>Show more</p>
        </div>
        <div class="expand-delivery-ares" *ngIf="shouldShowLess()" (click)="collapseAreas()">
          <p>Show less</p>
        </div>
        <div class="horizontal-separator"
             *ngIf="merchantFilters !== null && merchantFilters!.deliveryAreas.isNotEmpty()"></div>
        <div class="filter-by-title" *ngIf="merchantFilters !== null && merchantFilters!.cities.isNotEmpty()">
          <p i18n="@@cities">Cities</p>
          <div class="clear-all" (click)="onClearCitiesClicked()">
            <p i18n="@@clear">Clear</p>
          </div>
        </div>
        <div class="filter-by-item" *ngFor="let city of merchantFilters?.cities; let i = index;">
          <input type="checkbox" id="{{city.id}}" name="{{city.id}}" value="{{city.id}}"
                 [(ngModel)]="citiesCheckBoxes[i]"
                 (change)="filterResults(); filterAreas()">
          <label for="{{city.id}}">{{ city.name }}</label><br>
        </div>
      </div>

      <div class="filter-by-container-mobile" *ngIf="isMobileView" (click)="showModalFilters()">
        <img src="assets/filters-icon.svg" alt="filter">
        <p i18="@@filters">Filters</p>
        <div class="drop-down-img">
          <img src="assets/expand-more-icon.svg">
        </div>
      </div>

      <div class="merchants-list-container">
        <form [formGroup]="formGroup">
          <div class="search">
            <input formControlName="search" type="text" class="search-input" placeholder="Search" name=""
                   i18n-placeholder="@@search">
            <div (click)="search()">
              <img src="assets/search-icon.svg" alt="search">
            </div>
          </div>
        </form>
        <div>
          <div class="search-result-loading" *ngIf="loadingSearchResults">
            <img src="assets/loading.gif">
            <p i18n="@@loadingSearchResults">Loading Search Results...</p>
          </div>
          <div class="merchants-list" *ngIf="!loadingSearchResults">
            <merchant-list-item *ngFor="let merchant of merchants" [merchant]="merchant"></merchant-list-item>
          </div>
          <div class="text-center" *ngIf="merchants.isEmpty() && !loadingSearchResults">
            <img src="assets/empty-search-icon.svg">
            <div class="no-results">
              <p i18n="@@noResultsFound">No results found</p>
            </div>
            <div class="refine-search">
              <p i18n="@@noResultsFoundMessage">Please refine your search for enhanced results.</p>
            </div>
          </div>
        </div>
        <primary-button
          *ngIf="showLoadMoreButton"
          class="load-more-button"
          (onClick)="loadMore()"
          [loading]="loading"
          [enableKeyboardEvent]="false"
          title="{{loadMoreRestaurantsLabel}}">
        </primary-button>
      </div>
    </div>
  </div>

</div>
